import React from 'react'

const getGlobalWindowScrollPosition = () => {
  return {
    x:
      typeof window.scrollX !== 'undefined'
        ? window.scrollX
        : typeof document.documentElement.scrollLeft !== 'undefined'
        ? document.documentElement.scrollLeft
        : document.body.scrollLeft,
    y:
      typeof window.scrollY !== 'undefined'
        ? window.scrollY
        : typeof document.documentElement.scrollTop !== 'undefined'
        ? document.documentElement.scrollTop
        : document.body.scrollTop,
  }
}

export const useScroll = (ref?: React.RefObject<HTMLElement>) => {
  const [scroll, setScroll] = React.useState({
    x: 0,
    y: 0,
  })

  React.useEffect(() => {
    const el = ref?.current ?? null

    const onScroll = (_: Event) => {
      requestAnimationFrame(() => {
        if (el) {
          setScroll({
            x: el.scrollLeft,
            y: el.scrollTop,
          })
        } else {
          setScroll(getGlobalWindowScrollPosition())
        }
      })
    }

    ;(el ?? window).addEventListener('scroll', onScroll)

    return () => {
      ;(el ?? window).removeEventListener('scroll', onScroll)
    }
  }, [ref])

  return scroll
}
